import { STRINGS } from '@/constants/farmerSolutions'

const BannerHeader = () => (
  <p className="md:font-natosans-bold font-natosans-semibold md:text-4xl text-2xl md:leading-[1.4] leading-[1.5] text-neutral-100">
    {STRINGS.DEHAAT_APP_EXPERIENCE}
  </p>
)

export default BannerHeader
